import { useEffect, useState } from 'react';

import { ReloadOutlined } from '@ant-design/icons';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import { isStaticResourceLoadError, STATIC_RESOURCE_LOAD_ERROR_EVENT } from 'utils/staticResourceError';

function isModuleResourceElement(target) {
  return target instanceof HTMLScriptElement || (target instanceof HTMLLinkElement && target.rel === 'modulepreload');
}

export default function StaticResourceRefreshPrompt() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const showPrompt = () => setOpen(true);
    const handleVitePreloadError = (event) => {
      event.preventDefault();
      showPrompt();
    };
    const handleUnhandledRejection = (event) => {
      if (!isStaticResourceLoadError(event.reason)) return;
      event.preventDefault();
      showPrompt();
    };
    const handleResourceError = (event) => {
      if (isModuleResourceElement(event.target)) showPrompt();
    };

    window.addEventListener(STATIC_RESOURCE_LOAD_ERROR_EVENT, showPrompt);
    window.addEventListener('vite:preloadError', handleVitePreloadError);
    window.addEventListener('unhandledrejection', handleUnhandledRejection);
    window.addEventListener('error', handleResourceError, true);

    return () => {
      window.removeEventListener(STATIC_RESOURCE_LOAD_ERROR_EVENT, showPrompt);
      window.removeEventListener('vite:preloadError', handleVitePreloadError);
      window.removeEventListener('unhandledrejection', handleUnhandledRejection);
      window.removeEventListener('error', handleResourceError, true);
    };
  }, []);

  const handleRefresh = () => {
    const url = new URL(window.location.href);
    url.searchParams.set('__reload', Date.now().toString());
    window.location.replace(url.toString());
  };

  return (
    <Dialog open={open} maxWidth="xs" fullWidth disableEscapeKeyDown aria-labelledby="static-resource-refresh-dialog-title">
      <DialogTitle id="static-resource-refresh-dialog-title">页面需要刷新</DialogTitle>
      <DialogContent>
        <DialogContentText>页面所需资源已更新或不可用。请刷新页面后继续使用。</DialogContentText>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button variant="contained" startIcon={<ReloadOutlined />} onClick={handleRefresh} autoFocus>
          刷新页面
        </Button>
      </DialogActions>
    </Dialog>
  );
}
